var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modal_id,
            title: "返品",
            size: "xl",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
            scrollable: "",
          },
          on: { hide: _vm.closeModal },
        },
        [
          _c(
            "form",
            {
              staticClass: "form-group main_modal_div",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.updateHenpin.apply(null, arguments)
                },
              },
            },
            [
              _vm.errors.length != 0
                ? _c(
                    "div",
                    _vm._l(_vm.errors, function (e) {
                      return _c("ul", { key: e }, [
                        _c(
                          "li",
                          [
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v(_vm._s(e)),
                            ]),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "10px 0px" },
                },
                [
                  _c("label", [_vm._v("伝票番号")]),
                  _vm._v(" "),
                  _c("b-input", {
                    style: _vm.mitumori.cancel
                      ? "text-decoration: line-through; width: 200px;"
                      : "width: 200px;",
                    attrs: { type: "text", readonly: "" },
                    model: {
                      value: _vm.mitumori.m_code,
                      callback: function ($$v) {
                        _vm.$set(_vm.mitumori, "m_code", $$v)
                      },
                      expression: "mitumori.m_code",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("返品番号")]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      staticStyle: { width: "70px" },
                      on: { change: _vm.onHenpinChange },
                      model: {
                        value: _vm.henpin.sub_code,
                        callback: function ($$v) {
                          _vm.$set(_vm.henpin, "sub_code", $$v)
                        },
                        expression: "henpin.sub_code",
                      },
                    },
                    _vm._l(_vm.sel_henpin_sub_code, function (option) {
                      return _c(
                        "option",
                        { key: option.id, domProps: { value: option.value } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(option.text) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v("\n          \n        "),
                  _c("label", {}, [_vm._v("返品日")]),
                  _vm._v(" "),
                  _c("v-date-picker", {
                    staticClass: "date_picker",
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ inputValue, inputEvents }) {
                          return [
                            _c(
                              "b-input",
                              _vm._g(
                                { attrs: { value: inputValue, readonly: "" } },
                                inputEvents
                              )
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "icon_btn_del",
                                attrs: { variant: "danger" },
                                on: {
                                  click: function ($event) {
                                    _vm.henpin.henpin_on = null
                                  },
                                },
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "x", "aria-hidden": "true" },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.henpin.henpin_on,
                      callback: function ($$v) {
                        _vm.$set(_vm.henpin, "henpin_on", $$v)
                      },
                      expression: "henpin.henpin_on",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c("label", {}, [_vm._v("納品日")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "160px" },
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.nouhin.nouhin_on_fmt,
                      callback: function ($$v) {
                        _vm.$set(_vm.nouhin, "nouhin_on_fmt", $$v)
                      },
                      expression: "nouhin.nouhin_on_fmt",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c("label", {}, [_vm._v("請求日")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "160px" },
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.nouhin.seikyu_on_fmt,
                      callback: function ($$v) {
                        _vm.$set(_vm.nouhin, "seikyu_on_fmt", $$v)
                      },
                      expression: "nouhin.seikyu_on_fmt",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "10px 0px" },
                },
                [
                  _c("label", [_vm._v("品題")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "text", readonly: _vm.mitumori.readonly },
                    model: {
                      value: _vm.mitumori.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.mitumori, "title", $$v)
                      },
                      expression: "mitumori.title",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("品類")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "text", readonly: _vm.mitumori.readonly },
                    model: {
                      value: _vm.mitumori.teiki_type1,
                      callback: function ($$v) {
                        _vm.$set(_vm.mitumori, "teiki_type1", $$v)
                      },
                      expression: "mitumori.teiki_type1",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("品目")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "text", readonly: _vm.mitumori.readonly },
                    model: {
                      value: _vm.mitumori.teiki_type2,
                      callback: function ($$v) {
                        _vm.$set(_vm.mitumori, "teiki_type2", $$v)
                      },
                      expression: "mitumori.teiki_type2",
                    },
                  }),
                  _vm._v("\n          \n      "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "10px 0px" },
                },
                [
                  _c("label", [_vm._v("顧客")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "text", readonly: "" },
                    model: {
                      value: _vm.mitumori.client_company_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.mitumori, "client_company_name", $$v)
                      },
                      expression: "mitumori.client_company_name",
                    },
                  }),
                  _vm._v(" "),
                  !_vm.client_loading
                    ? _c(
                        "b-button",
                        { staticClass: "icon_btn", attrs: { variant: "info" } },
                        [
                          _c("b-icon", {
                            attrs: { icon: "search", "aria-hidden": "true" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("敬称")]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      staticStyle: { width: "70px" },
                      model: {
                        value: _vm.henpin.keisyou,
                        callback: function ($$v) {
                          _vm.$set(_vm.henpin, "keisyou", $$v)
                        },
                        expression: "henpin.keisyou",
                      },
                    },
                    _vm._l(_vm.sel_keisyou, function (option) {
                      return _c(
                        "option",
                        { key: option.id, domProps: { value: option.value } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(option.text) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("顧客担当者")]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { disabled: false },
                      model: {
                        value: _vm.mitumori.client_person_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori, "client_person_id", $$v)
                        },
                        expression: "mitumori.client_person_id",
                      },
                    },
                    [
                      _c("option"),
                      _vm._v(" "),
                      _vm._l(_vm.sel_client_person, function (option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(option.text) +
                                "\n          "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v("\n          \n        "),
                  _c("label", [_vm._v("担当者")]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { disabled: true },
                      model: {
                        value: _vm.mitumori.user_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori, "user_id", $$v)
                        },
                        expression: "mitumori.user_id",
                      },
                    },
                    _vm._l(_vm.sel_person, function (option) {
                      return _c(
                        "option",
                        { key: option.id, domProps: { value: option.value } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(option.text) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "10px 0px" },
                },
                [
                  _c("label", [_vm._v("備考")]),
                  _vm._v(" "),
                  _c("b-form-textarea", {
                    staticStyle: { width: "300px" },
                    attrs: { id: "textarea", rows: "2", "max-rows": "2" },
                    model: {
                      value: _vm.henpin.note,
                      callback: function ($$v) {
                        _vm.$set(_vm.henpin, "note", $$v)
                      },
                      expression: "henpin.note",
                    },
                  }),
                  _vm._v("\n         \n        "),
                  _c(
                    "b-button",
                    {
                      staticStyle: { "margin-left": "500px" },
                      attrs: { type: "submit", variant: "primary" },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "save" } }),
                      _vm._v(" 保存\n        "),
                    ],
                    1
                  ),
                  _vm._v("\n         \n        "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "danger",
                        disabled: _vm.henpin_sub_code == 1,
                      },
                      on: { click: _vm.delHenpin },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "save" } }),
                      _vm._v(" 削除\n        "),
                    ],
                    1
                  ),
                  _vm._v("\n         \n        "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        id: "checkbox-c",
                        value: 1,
                        "unchecked-value": 0,
                        name: "checkbox-c",
                      },
                      on: { change: _vm.henpin_submit },
                      model: {
                        value: _vm.henpin.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.henpin, "status", $$v)
                        },
                        expression: "henpin.status",
                      },
                    },
                    [_vm._v("\n          返品確定\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v("\n    商品\n    "),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticStyle: { width: "1200px" } },
              [
                _c("b-table-filter", {
                  attrs: {
                    maxHeight: _vm.maxHeight,
                    filter_list: _vm.filter_list,
                    filter_val: _vm.filter_val,
                    data_list_field: _vm.data_list_field,
                    data_list: _vm.data_list,
                    filter_enable: false,
                    edit_disabled: _vm.henpin.status == 1,
                  },
                  on: { on_edit: _vm.modalShow },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-inline", staticStyle: { width: "1190px" } },
            [
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "0px 0px 0px auto" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "ml-auto d-flex align-items-center" },
                    [
                      _c("label", [_vm._v("返品合計")]),
                      _vm._v(" "),
                      _c("b-input", {
                        staticStyle: { width: "200px", "text-align": "right" },
                        attrs: {
                          value:
                            _vm.sum_henpin_total +
                            " (税 " +
                            _vm.sum_henpin_tax +
                            ")",
                          type: "text",
                          readonly: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm._v("\n    相殺\n    "),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticStyle: { width: "560px" } },
              [
                _c("b-table-filter", {
                  attrs: {
                    maxHeight: _vm.maxHeight,
                    filter_list: _vm.filter_list,
                    filter_val: _vm.filter_val,
                    data_list_field: _vm.offset_data_list_field,
                    data_list: _vm.offset_data_list,
                    filter_enable: false,
                  },
                  on: { on_delete: _vm.delOffset },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("SelectMitumori", { on: { on_select: _vm.onSelectMitumori } }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                width: "560px",
                margin: "-10px 0px 0px 0px",
                display: "flex",
                "align-items": "center",
                "justify-content": "space-between",
              },
            },
            [
              _c(
                "div",
                [
                  !_vm.item_loading2
                    ? _c(
                        "b-button",
                        {
                          staticClass: "icon_btn_w",
                          attrs: { variant: "info", disabled: false },
                          on: {
                            click: function ($event) {
                              return _vm.selectMitumoriModalShow(-1)
                            },
                          },
                        },
                        [
                          _c("b-icon", {
                            attrs: { icon: "plus", "aria-hidden": "true" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.item_loading2
                    ? _c(
                        "b-button",
                        {
                          staticClass: "icon_btn_w",
                          attrs: { variant: "info", disabled: "" },
                        },
                        [
                          _c("span", {
                            staticClass: "spinner-border spinner-border-sm",
                            attrs: { role: "status", "aria-hidden": "true" },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "flex-wrap": "wrap",
                    "justify-content": "flex-end",
                  },
                },
                [
                  _c("label", [_vm._v("合計")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "200px", "text-align": "right" },
                    attrs: {
                      value: _vm.offset_total,
                      type: "text",
                      readonly: "",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "modal-mitumori_item",
                title: _vm.mitumori_item_title,
                "header-bg-variant": "dark",
                "header-text-variant": "light",
                "body-bg-variant": "light",
                "hide-footer": "",
                centered: "",
              },
            },
            [
              _c("div", { staticClass: "modal_div" }, [
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c(
                      "label",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover.bottom.v-info",
                            value: _vm.tooltip_item,
                            expression: "tooltip_item",
                            modifiers: {
                              hover: true,
                              bottom: true,
                              "v-info": true,
                            },
                          },
                        ],
                      },
                      [
                        _vm._v("\n            商品 "),
                        _c("b-icon", {
                          attrs: {
                            icon: "info-circle-fill",
                            scale: "1",
                            variant: "info",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "300px" },
                      attrs: { type: "text", readonly: "" },
                      on: { click: _vm.selectItemModalShow },
                      model: {
                        value: _vm.mitumori_detail.master_item_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori_detail, "master_item_name", $$v)
                        },
                        expression: "mitumori_detail.master_item_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("品名")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "300px" },
                      attrs: { type: "text", readonly: "" },
                      model: {
                        value: _vm.mitumori_detail.item_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori_detail, "item_name", $$v)
                        },
                        expression: "mitumori_detail.item_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("数量")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: { type: "number", min: "0", readonly: "" },
                      model: {
                        value: _vm.mitumori_detail.quantity,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori_detail, "quantity", $$v)
                        },
                        expression: "mitumori_detail.quantity",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("返品数量")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: { type: "number", min: "0" },
                      model: {
                        value: _vm.henpin_detail.quantity,
                        callback: function ($$v) {
                          _vm.$set(_vm.henpin_detail, "quantity", $$v)
                        },
                        expression: "henpin_detail.quantity",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    _c(
                      "b-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.$bvModal.hide("modal-mitumori_item")
                          },
                        },
                      },
                      [
                        _c("b-icon", { attrs: { icon: "x" } }),
                        _vm._v("取消\n          "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.editHenpinDetail },
                      },
                      [
                        _c("b-icon", { attrs: { icon: "save" } }),
                        _vm._v(" 保存\n          "),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }